import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { DEFAULT_WA } from "../lib/site";

export default function CtaBand({ title = "Need a trailer placed today?", hindi = "Need a trailer today? One call away." }) {
    return (
        <section className="bg-navy" data-testid="cta-band">
            <div className="container-x flex flex-col items-start justify-between gap-8 py-16 lg:flex-row lg:items-center lg:py-20">
                <Reveal>
                    <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-paper sm:text-4xl lg:text-5xl">
                        {title}
                    </h2>
                    <p className="mt-3 font-hindi text-base text-paper/70">{hindi}</p>
                </Reveal>
                <Reveal delay={0.1} className="flex flex-wrap gap-4">
                    <Link
                        to="/contact#quote"
                        data-testid="cta-quote-btn"
                        className="btn-primary"
                    >
                        Get a Trailer Quote
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                    <a
                        href={DEFAULT_WA}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-whatsapp-btn"
                        className="btn-whatsapp"
                    >
                        <MessageCircle className="h-4 w-4" />
                        WhatsApp Enquiry
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
